import { z } from 'zod';

export const optionSchema = z.object({
  option: z.string(),
  is_true: z.boolean(),
});

export const questionQuerySchema = z.object({
  category: z.string(),
  chapter: z.number(),
  chapter_name: z.string(),
  correct_answer: z.string(),
  correct_feedback: z.string().nullable(),
  course: z.object({
    course_id: z.string(),
    course_name: z.string(),
  }),
  id: z.number(),
  incorrect_feedback: z.string().nullable(),
  options: z.array(optionSchema),
  question_text: z.string(),
  topic: z.number(),
  topic_name: z.string(),
  type: z.literal('MCQ').or(z.literal('MMCQ')),
});
